import React from 'react';

import linkStickerStory from 'src/assets/starterDashboardV2/readyToShare/linkStickerStory.png';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles, LinkStickerStyles } from './Body.styles';
import type { InstagramStoryComponentsProps } from './types';

export function Body(props: InstagramStoryComponentsProps): React.JSX.Element {
	const { size, loading, previewImageUrl } = props;

	const styles = BodyStyles({ size });

	if (loading) {
		return (
			<SkeletonContainer
				loading={loading}
				className={styles}
				shapeColorClassName="bg-icon-weak"
				data-testid="empty-container"
			>
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return (
		<>
			<div className="relative">
				<img src={linkStickerStory} className={LinkStickerStyles({ size })} aria-hidden alt="" />
			</div>
			<img data-testid="body-image" className={styles} src={previewImageUrl} alt="" aria-hidden />
		</>
	);
}
